<app-site-widget
	[title]="title"
	[elementId]="elementId"
	chartType="grid"
	[widgetClass]="widgetClass"
	[siteWidgetOptions]="siteWidgetOptions"
	[widgetOptions]="{hasPrint: false}"
	[data]="data"
	[tableColumns]="tableColumns"
	[siteId]="siteId"
	[customerId]="customerId"
></app-site-widget>